export default __webpack_public_path__ + "static/media/K2700Gallery4.1a66076d.jpg";